var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-ios-camera",
    "data-name": "Icon ionic-ios-camera",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.663,
    height: 10.998,
    viewBox: "0 0 14.663 10.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M18.348,17.489a2.2,2.2,0,1,1-2.2-2.2A2.2,2.2,0,0,1,18.348,17.489Z",
    transform: "translate(-8.821 -11.264)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M18,9.708H15.918a.62.62,0,0,1-.458-.206c-1.084-1.214-1.493-1.627-1.936-1.627H10.258c-.447,0-.886.412-1.974,1.631a.608.608,0,0,1-.454.2H7.673V9.4A.306.306,0,0,0,7.368,9.1H6.375a.306.306,0,0,0-.305.305v.305H5.783A1.238,1.238,0,0,0,4.5,10.88V17.6a1.322,1.322,0,0,0,1.279,1.272H18A1.224,1.224,0,0,0,19.163,17.6V10.88A1.138,1.138,0,0,0,18,9.708ZM11.984,17.36a3.265,3.265,0,1,1,3.108-3.108A3.268,3.268,0,0,1,11.984,17.36ZM15.5,11.923a.5.5,0,1,1,.5-.5A.5.5,0,0,1,15.5,11.923Z",
    transform: "translate(-4.5 -7.875)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.df25cb9781c4c55761e8284d3814fd1c.svg";
export { ForwardRef as ReactComponent };